module.exports = __webpack_public_path__ + "00bacc1034f54f8ac5232552563676d6.pdf";